import { EnvironmentOutlined } from '@ant-design/icons';
import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { Button, Tooltip } from 'antd';
import { type IMapLayer } from '../../layers/MapLayer.ts';
import { MapWidgetLogic } from '../../MapWidgetLogic.ts';
import { createCadastralPresetLayer } from './cadastralPreset.ts';

export interface ICadastralPresetButtonProps {
  /** Editor dei layer del widget mappa */
  editor: RelationEditor<IMapLayer>;
}

/**
 * Pulsante per aggiungere un layer pre-compilato con configurazione catastale.
 * Apre il drawer di configurazione layer con i valori del preset catastale.
 * Disabilitato se esiste già un layer con `cadastralPreset: true`.
 */
export function CadastralPresetButton(props: ICadastralPresetButtonProps) {
  const { editor } = props;

  const alreadyExists = editor.items.some(
    layer => layer.intersection?.cadastralPreset,
  );

  const isUrlMissing = !MapWidgetLogic.getCadastralLayerUrl().trim();

  let disabledReason: string | undefined;
  if (alreadyExists) {
    disabledReason = 'È già presente un layer con preset catastale';
  } else if (isUrlMissing) {
    disabledReason =
      'Configura CADASTRAL_LAYER_URL per usare il preset catastale';
  }

  return (
    <Tooltip title={disabledReason}>
      <Button
        type="dashed"
        block
        size="large"
        disabled={alreadyExists || isUrlMissing}
        icon={<EnvironmentOutlined aria-hidden="true" />}
        onClick={e => {
          e.stopPropagation();
          editor.handle.open(createCadastralPresetLayer());
        }}
      >
        Aggiungi Layer Particelle Catastali
      </Button>
    </Tooltip>
  );
}
